export default __webpack_public_path__ + "static/media/Proxima Nova Bold.aacabaf2.ttf";